import styled from 'styled-components';


/*  Styles for rebuttal slides */

export const CreditScoreStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
    height: 100%;
    width: 100%;
    padding: 20px;
    img {
        width: 100%;
        max-width: 600px;
    }
    div {
        padding: 10px 0;
        width: 100%;
        max-width: 620px;
    }
`;

export const LoanCalculatorStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: ${props => props.desktop ? 'row' : 'column'};
    margin-bottom: ${props => props.desktop ? '0' : '2rem'};
    height: 100%;
    width: 100%;
    padding: 10px;
    >div {
        width: 100%;
        display: inherit;
        flex-direction: column;
        margin: 15px;
        label, div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size 16px;
            margin: 10px 0;
            height: 100%;
            font-weight: bold;
        }
    }
`;

export const LoanCalculatorInputs = styled.div`
    span {
        border: 1px solid #EBEBEB;
        border-bottom-width: 3px;
        font-weight: bold;
        width: 50%;
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
    }
    input::-webkit-inner-spin-button {
        display: none;
    }
    input::placeholder {
        font-weight: bold;
    }
`;

export const LoanCalculatorTotals = styled.div`
    background: #FFFFFF;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 15px;
    height: 100%;
    >div {
        >span:nth-child(2) {
            background: #EBEBEB;
            border-radius: 12px;
            text-align: right;
            width: 50%;
            padding: 10px;
            display: flex;
            justify-content: space-between;
        }
        #first-row {
            background: #CAE9FF;
        }
        #last-row {
            background: #0080FF;
            color: #fff;
        }
    }
    h2 {
        text-align: center;
        font-size: 20px;
        border-bottom: 1px solid #0080FF; 
        line-height: 0.1em;
        margin: 15px 0 20px;
        span { 
            background: #fff; 
            padding: 0 10px; 
        }
    }
`;

export const LoanCalculatorInput = styled.input`
    border: none;
    outline: none;
    text-align: right;
    height: 100%;
    width: 100%;
`;


export const ClientPortalStyle = styled.div`
width: 100%;
display: flex;
flex-direction: ${props => props.desktop ? 'row' : 'column'};
justify-content: center;
${props => !props.desktop && 'align-items: center'};
padding: 0px;
gap: 32px;

position: absolute;
${props => props.desktop && 'width: 696px'};
left: ${props => props.desktop ? '31px' : '0'};
top: 30px;
${props => props.desktop && 'align-items: start'};


.bullets {
    box-sizing: border-box;
    /* Auto layout */
    
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    gap: 16px;

    background: #F9F9F9;
    box-shadow: 0px 4px 8px rgba(26, 26, 26, 0.12);
    border-radius: 12px;
    /* Inside auto layout */

    align-self: stretch;
    flex-grow: 0;
    
        >label {
            margin-left: 20px;
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 19px;
            /* identical to box height */
            color: #0A1E28;
        }
        >ul {
            margin-top: -10px;
        }
        >li {
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 180%;
            /* or 23px */
            color: #1A1A1A;
        }
    }
`;

export const InterestCalculatorStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    ${props => !props.mobile && 'height: 100%'};
    >div {
        display: flex;
        flex-direction: ${props => props.mobile ? 'column' : 'row'};
        ${props => props.mobile && 'margin: 20px 0'};
    }
`;

export const FinancialPathStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    font-size: 12px;
    height: 100%;
    >div {
        width: 75%;
        display: flex;
        flex-direction: ${props => props.desktop ? 'row' : 'column'};
    }
`;

export const FicoStyle = styled.div`
    display: flex;
    flex-direction: ${props => props.desktop ? 'row': 'column'};
    justify-content: space-between;
    ${props => props.desktop && 'height: 100%'};
    #credit-score {
        background: #091D27;
        width: 115px;
        height: 55px;
        border-radius: 45px;
        color: white;
        font-weight: bold;
        font-size: 26px;
        position: relative;
        top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    img {
        width: 80%;
        margin-top: 45px;
        ${props => props.desktop && 'margin-left: 25px'};
    }
    >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: ${props => props.desktop ? '50%' : '100%'};
        height: 100%;
    }
`;

export const FicoCreditSection = styled.div`
    align-items: center;
    justify-content: flex-start;
`;

export const DTISlider = styled.div`
    width: 100%;
    position: relative;
    ${props => props.desktop && 'margin-right: 30px'};
    height: 100%;
    >div:first-child {
        width: 100%;
        border-radius: 28px;
        height: 30px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        background: linear-gradient(to right, #5AEE56 0%, #5AEE56 35%, #F9E534 35%, #F9E534 49%, #FF5959 49%, #FF5959 100%);
    }
    #labels {
        display: flex;
        flex-direction: row;
        width: ${props => props.desktop ? '93%' : '88%'};
        position: relative;
    }
    img {
        position: absolute;
        left: ${({ dti }) => {
            const dtiAsNumber = dti.slice(0, -1);
            return dtiAsNumber >= 97 ? '97%' : `${dtiAsNumber - 1}%`;
        }};
        height: 54.5px;
        width: 33px;
        top: 0%;
        z-index: 11;
    }
`;

export const DTILabel = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    font-size: ${props => props.desktop ? '20px' : '17px'};
    color: #1E1E1E;
    ${({ value }) => {
        const valueAsNumber = parseInt(value.slice(0, -1));
        const left = valueAsNumber >= 100 ? 100 : valueAsNumber;
        return `left: ${left}%`;
    }};
    ${({ dti, value }) => dti === value && (
        `display: flex;
         align-items: center;
         justify-content: center;
         z-index: 10;
         background: #E3E3E3;
         border-radius: 50%;
         margin-top: 2%;
         width: 57px;
         height: 57px;
         box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);`)
    };
`;

export const DTIStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 14px;
`;
